// extracted by mini-css-extract-plugin
export var modalBox = "Q_xd";
export var backdrop = "Q_xf";